module.exports = __webpack_public_path__ + "img/lengqueta.bcd863d3.png";